import { render, staticRenderFns } from "./product-target-picker.vue?vue&type=template&id=f276b872&scoped=true&"
import script from "./product-target-picker.vue?vue&type=script&lang=js&"
export * from "./product-target-picker.vue?vue&type=script&lang=js&"
import style0 from "./product-target-picker.vue?vue&type=style&index=0&id=f276b872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f276b872",
  null
  
)

export default component.exports